export default {
    init() {
        this.serviceQuantityToggle();
        this.orderInnerRowClone();
        this.uploadButton();
        this.upload1Document();
        this.DragAndDrop1DocumentUpload();
    },


    serviceQuantityToggle(){
        $("body").on("select2:select", '.order-service', function (e) {
            var select_val = $(e.currentTarget).val();
            if(select_val != ''){
                $(this).closest('.add-row-wrap').find('.service-quantity').removeClass('hidden');
            } else {
                $(this).closest('.add-row-wrap').find('.service-quantity').addClass('hidden');
            }
        });
    },

    orderInnerRowClone() {
        let select2Options = {
            placeholder: 'Select',
            minimumResultsForSearch: -1
        };

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-row') && $(e.target).hasClass('new')) {
                let parent = $(e.target).closest('.add-row-wrap');
                let validation = true;
                parent.find('.input-wrap').removeClass('error');

                $(".input-wrap:not(.disabled) select.select2", parent).each(function () {
                    let element = $(this);
                    if (element.val() === "") {
                        validation = false;
                        element.closest('.input-wrap').addClass('error');
                    }
                });

                $(".input-wrap:not(.disabled) .form-input", parent).each(function () {
                    let element = $(this);
                    if (element.val() === "") {
                        validation = false;
                        element.closest('.input-wrap').addClass('error');
                    }
                });

                if (validation ==  true) {
                    parent.find('.input-wrap').removeClass('error');
                    $('.new-row select').select2('destroy');
                    let clonedRow = parent.clone();
                    clonedRow.insertBefore(parent).attr('id', 'new' + getRandomInt(9, 99));
                    parent.parent().find('.add-row-wrap').eq(1).removeClass('new-row').find('.add-row.new').hide();
                    parent.parent().find('.add-row-wrap.new-row .form-input').val('');
                    parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete').addClass('show');
                    let newDeleteBtn = parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete');
                    deleteRow(newDeleteBtn);
                    parent.parent().find('.add-row-wrap.new-row .service-quantity').addClass('hidden');

                    $('.add-row-wrap select').select2(select2Options);
                }
            }
        });

        function deleteRow(btn) {
            btn.on('click', function () {
                $(this).closest('.add-row-wrap').remove();
            });
        }

        function getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min) + min);
        }
    },

    uploadButton(){
        $(document).on('click', '.upload-document-popup-btn', function(e){
            e.preventDefault();
            let popup = $(this).parent().find('.upload-document-popup-wrap');
            popup.fadeToggle(300);
        });

        $(document).on('click', '.upload-document-popup-btn-close', function(e){
            e.preventDefault();
            let popup = $(this).closest('.content-card--content').find('.upload-document-popup-wrap');
            popup.fadeOut(300);
        });

        $(document).on('submit', '.upload-document-popup-form', function (e) {
            e.preventDefault();
            let errorMsg = $(this).find('.error-message');
            errorMsg.hide();
            let validation = true;

            $(".form-input", this).each(function () {
                let element = $(this);
                if (element.val() === "") {
                    element.closest('.form-item').addClass('input-invalid');
                    validation = false;
                } else {
                    element.closest('.form-item').removeClass('input-invalid');
                }
            });

            var fileInput = $(this).find('.import-file');
            var formItem = fileInput.closest('.form-item');

            if (fileInput.get(0).files.length === 0) {
                // If no file is selected, prevent form submission and add input-invalid class to form-item
                formItem.addClass('input-invalid');
                validation = false;
                // Optionally, you can show an error message or perform any other action here
            } else {
                // If a file is selected, remove input-invalid class from form-item
                formItem.removeClass('input-invalid');
            }

            if (validation == true) {
                let popup = $(this).closest('.content-card--content').find('.upload-document-popup-wrap');
                popup.fadeOut(300);
            } else {
                errorMsg.slideDown(300);
            }
        });
    },

    upload1Document() {
        const self = this;
        let fileTypes = ['pdf'];
        let maxAllowedSize = 30 * 1024 * 1024;
        let importFileInput = $('.form-photo-upload-wrap .import-file');

        importFileInput.on('change', function () {
            let importParent = $(this).parent().parent();
            let wrongFile = importParent.find('.wrong-file-type');
            let uploadArea = importParent.find('.form-photo-upload-wrap--upload-box');
            let filesList = importParent.find('.form-photo-upload-wrap--list');


            if ($(this)[0].files.length > 0) {
                uploadArea.removeClass('invalid');
                let filesAllowed = [];
                let countInvalid = false;
                let files = $(this)[0].files;

                for (let i = 0; i < files.length; i++) {
                    if (files[i].size < maxAllowedSize) {
                        let extension = files[i].name.split('.').pop().toLowerCase();
                        let isSuccess = fileTypes.indexOf(extension) > -1;
                        if (isSuccess) {
                            filesAllowed.push(files[i]);
                        } else {
                            countInvalid = true;
                        }
                    } else {
                        countInvalid = true;
                    }
                }

                if (filesAllowed.length >= 1) {
                    uploadArea.addClass('active');
                    uploadArea.find('.text').text('Uploaded new document');
                }

                var oFReader = new FileReader();
                for (let i = 0; i < filesAllowed.length; i++) {
                    oFReader.readAsDataURL(filesAllowed[i]);
                    oFReader.onload = function (oFREvent) {
                        let numberOfChildren = filesList.children().length;
                        if (numberOfChildren < 30) {
                            filesList.html(' <li class="item"><img src="' + oFREvent.target.result + '" alt=""></li>');
                        }
                    }
                }



                if (countInvalid == true) {
                    uploadArea.addClass('invalid');
                    wrongFile.slideDown(300);
                } else {
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                }
            }
        });
    },

    DragAndDrop1DocumentUpload() {
        const self = this;
        let fileTypes = ['.pdf'];
        let maxAllowedSize = 30 * 1024 * 1024;
        let wrongFile = $('.form-photo-upload-wrap .wrong-file-type');
        let uploadArea = $('.form-photo-upload-wrap .form-photo-upload-wrap--upload-box');
        let filesList = $('.form-photo-upload-wrap .form-photo-upload-wrap--list');
        let importFileInput = $('.form-photo-upload-wrap .import-file');
        let explorerCheck = false;
        let safariCheck = false;

        if (navigator.userAgent.indexOf('Trident/') !== -1) {
            explorerCheck = true;
        } else {
            explorerCheck = false;
        }

        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            safariCheck = true;
        } else {
            safariCheck = false;
        }

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        function highlight() {
            uploadArea.addClass('hover');
        }

        function dropFiles(e) {
            uploadArea.removeClass('hover');

            //If delete previous import
            //filesList.empty();

            let filesAllowed = [];
            let files = e.dataTransfer.files;
            let countInvalid = false;

            for (let i = 0; i < files.length; i++) {
                if (files[i].size < maxAllowedSize) {
                    let extension = files[i].name.split('.').pop().toLowerCase();
                    let isSuccess = fileTypes.indexOf(extension) > -1;
                    if (isSuccess) {
                        filesAllowed.push(files[i]);
                    } else {
                        countInvalid = true;
                    }
                } else {
                    countInvalid = true;
                }
            }

            if (countInvalid == true) {
                uploadArea.addClass('invalid');
                wrongFile.slideDown(300);
            } else {
                wrongFile.slideUp(300);
                uploadArea.removeClass('invalid');
            }

            generateFileList(filesAllowed);
            document.querySelector('.form-photo-upload-wrap--upload-box .import-file').files = new FileListItem(filesAllowed);
        }

        function generateFileList(files) {
            if (files.length >= 1) {
                uploadArea.addClass('active');
                uploadArea.find('.text').text('Uploaded new document');
            }
            for (let file of files) {
                let numberOfChildren = filesList.children().length;
                if (numberOfChildren < 30) {
                    filesList.append(`<div class="item">"${file.name}" <span data-name="${file.name}"></span></div>`);
                }
            }
        }

        function FileListItem(a) {
            a = [].slice.call(Array.isArray(a) ? a : arguments)
            for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
            if (!d) throw new TypeError("expected argument to FileList is File or array of File objects")
            for (b = (new ClipboardEvent("")).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
            return b.files
        }
    },

}